export default "__VITE_ASSET__Dsxutqb___"